<template>
  <div class="container py-10">
    <transition name="fade" mode="out-in">
      <div v-if="submitted" class="text-center py-10">
        <h2>Successfully Submitted</h2>
        <p>Your form has been submitted and will be processed soon.</p>
        <d-btn href="https://awiqcp.org/" style="margin-top: 15px">
          Return Home
        </d-btn>
      </div>
      <div v-else class="flex flex-wrap -mx-5">
        <div class="w-full md:w-5/12 lg:w-4/12 px-5">
          <h1 class="font-bold text-primary-500 text-3xl">
            Qualify Credentials
          </h1>
          <p class="mb-5">
            Send QCP credential information to specified parties. You may request to have your credentials sent to up to three separate individuals. </b>
          </p>
        </div>
        <div class="w-full md:w-7/12 lg:w-8/12 px-5">
          <transition name="fade" mode="out-in">
            <page-one v-if="currentPage == 1" />
            <page-two v-if="currentPage == 2" />
            <page-three v-if="currentPage == 3" />
            <page-four v-if="currentPage == 4" />
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import PageOne from './components/QualifyCredentials/PageOne.vue';
  import PageTwo from './components/QualifyCredentials/PageTwo.vue';
  import PageThree from './components/QualifyCredentials/PageThree.vue';
  import PageFour from './components/QualifyCredentials/PageFour.vue';

  const { mapGetters, mapActions } = createNamespacedHelpers('qualifyCredentialsForm');

  export default {
    parent: true,
    components: {
      PageOne,
      PageTwo,
      PageThree,
      PageFour,
    },

    computed: {
      ...mapGetters([
        'currentPage',
        'submitted',
      ]),
    },

    mounted() {
      this.getCountries();
    },

    methods: {
      ...mapActions([
        'getCountries',
      ]),
    },
  };
</script>